import React, { useMemo } from 'react';
import SegmentDonutChart, { type DonutSegmentData, INSIGHTS_DONUT_DIMENSIONS } from './SegmentDonutChart';
import { SEARCE_COLORS } from '../../theme';

export interface TierDistribution {
  tier1: number;
  tier2: number;
  tier3: number;
  tier4: number;
}

interface EmployeesByTierPieChartProps {
  /** Filtered tier counts (tier1–tier4). */
  tierDistribution: TierDistribution | null;
}

/**
 * Employee tier distribution donut — wraps {@link SegmentDonutChart} with tier colors, bottom legend, and hover details.
 */
const EmployeesByTierPieChart: React.FC<EmployeesByTierPieChartProps> = ({ tierDistribution }) => {
  const tierData: DonutSegmentData[] = useMemo(
    () =>
      !tierDistribution
        ? []
        : [
            { name: 'Tier 1', value: tierDistribution.tier1, color: SEARCE_COLORS.success },
            { name: 'Tier 2', value: tierDistribution.tier2, color: SEARCE_COLORS.primary },
            { name: 'Tier 3', value: tierDistribution.tier3, color: '#FFC107' },
            { name: 'Tier 4', value: tierDistribution.tier4, color: SEARCE_COLORS.error },
          ],
    [tierDistribution]
  );

  const totalEmployees = useMemo(() => tierData.reduce((s, t) => s + t.value, 0), [tierData]);

  if (!tierDistribution) return null;

  return (
    <SegmentDonutChart
      data={tierData}
      centerValue={totalEmployees}
      centerLabel="Total Employees"
      tooltipUnitLabel="employees"
      {...INSIGHTS_DONUT_DIMENSIONS}
    />
  );
};

export default EmployeesByTierPieChart;
